<template lang="pug">
  div.container-fluid.animated.fadeIn
    nav(aria-label="breadcrumb")
      b-breadcrumb
        b-breadcrumb-item
          router-link(to="/rb")
            i.fas.fa-running
            span.ml-1 {{ $t("ui.running_ball") }}
        b-breadcrumb-item
          router-link(to="/rb/matchfeed")
            i.fas.fa-rss
            span.ml-1 {{ $t("ui.match_feed") }}
        b-breadcrumb-item
          span {{ matchId }}
    div.row
      div.col-md-12
        div.card
          div.card-header
            div.row
              div.col-md-12.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="icon-arrow-left"
                  :text="$t('ui.back')"
                  type="button"
                  @click.native="$emit('deselect')"
                  variant="secondary"
                  size="sm"
                  ).mb-1
            div.row.mb-1
              div.col-md-12
                div.form-row
                  div.col-sm-9.col-md-6.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        i.icon-magnifier
                      DebounceInput(required autofocus type="text" v-model="mfSearch" :placeholder="$t('message.search_by_id_name_desc')")
                  div.col-sm-3.col-md-1.mb-1
                    b-form-radio-group(
                      buttons
                      v-model="filterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="id") {{ $t("ui.id") }}
                      b-form-radio(value="name") {{ $t("ui.name") }}
                      b-form-radio(value="desc") {{ $t("ui.description") }}
            div.row.mb-1
              div.col-md-2
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fas.fa-sort
                  b-form-select(v-model="sort_type" @change="getMatchFeeds")
                    option(value="asc") {{ $t("ui.ascending") }}
                    option(value="desc") {{ $t("ui.descending") }}
              div.col-md-3
                b-input-group(size="sm").mb-1
                  b-input-group-text(slot="prepend")
                    i.fas.fa-trophy
                  b-input(:value="league" readonly).text-uppercase
              div.col-md-3
                b-input-group(size="sm").mb-1
                  b-input-group-text(slot="prepend")
                    i.fas.fa-gamepad
                  b-input(:value="home + '  vs  ' + away" readonly).text-uppercase
            div.row.col-md-12.mb-1
              div(width="10%").mr-3
                SubmitButton(:loading="loading" icon="icon-reload" :text="$t('ui.refresh')" @click="search" size="sm" variant="info")
              div(width="30%").col-md-3
                b-input-group(size="sm").mb-1
                  b-input-group-text(slot="prepend")
                    div.d-flex.justify-content-center.align-items-center
                      label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                        input.switch-input(type="checkbox" v-model="$options.refreshEnabled" @change="toggleRefresh()")
                        span.switch-slider(:data-checked='on' :data-unchecked='off')
                  b-input(v-model="refreshTime" type="range" min="3" max="10")
                  b-input-group-text(slot="append")
                    div(style="text-transform: none;") {{ refreshTime }} s
              //- div(width="30%").col-md-2
              //-   b-input-group(size="sm")
              //-       b-input-group-text(slot="prepend")
              //-         i.fas.fa-comment
              //-       b-form-select(v-model="rtfType" ref="rtfType")
              //-         option(value=-1 disabled selected)
              //-           | {{ $t("message.select_option") }}
              //-         option(v-for="info in rtfList" v-bind:value="info.RTFCommentaryID")
              //-           | {{ info.RTFCommentaryDescription }} ({{ info.RTFCommentaryID}})
              //- div(width="20%").col-md-2
              //-   SubmitButton(
              //-     :loading="loading"
              //-     icon="fas fa-paper-plane"
              //-     :text="$t('ui.send')"
              //-     type="button"
              //-     @click="sendRBData"
              //-     variant="danger"
              //-     size="sm"
              //-   )
          div.card-body
            div.row.mb-2
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="detailTotalRow"
                  :per-page="getMFPageSize"
                  v-model="currentDetailPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.mfPageSizeOptions" :value="getMFPageSize" @input="changedMFPageSize")
                  b-input(:value="detailTotalRow" readonly)
            div.row.clusterize
              div.col-md-12.clusterize-scroll(style="max-height: 46vh; !important")
                table.tablex(style="width: 100%;" v-columns-resizable)
                  thead
                    tr
                      th.text-center.sticky-position(width="5%")
                        span(:title='$t("ui.event_id")') {{ $t("ui.event_id") }}
                      th.text-center.sticky-position(width="5%")
                        span(:title='$t("ui.rtf_id")') {{ $t("ui.rtf_id") }}
                      th.text-left.sticky-position(width="14%")
                        span(:title='$t("ui.rtf_name")') {{ $t("ui.rtf_name") }}
                      th.sticky-position(width="14%")
                        span(:title='$t("ui.description")') {{ $t("ui.description") }}
                      th.text-center.sticky-position(width="3%")
                        span(:title="$t('ui.danger_zone')") {{ $t("ui.short.danger_zone") }}
                      th.text-right.sticky-position(width="5%")
                        span(:title=' $t("ui.play_time")') {{ $t("ui.play_time") }}
                      th.sticky-position(width="10%")
                        span(:title='$t("ui.last_update_time")') {{ $t("ui.last_update_time") }}
                      th.text-left.sticky-position(width="10%")
                        span(:title="$t('ui.arrive_time')") {{ $t("ui.arrive_time") }}
                      th.text-left.sticky-position(width="10%")
                        span(:title="$t('ui.deliver_time')") {{ $t("ui.deliver_time") }}
                      th.text-right.sticky-position(width="8%")
                        span(:title="$t('ui.arrive_time_in_ms')") {{ $t("ui.short.arrive_time_in_ms") }}
                      th.text-right.sticky-position(width="8%")
                        span(:title="$t('ui.deliver_time_in_ms')") {{ $t("ui.short.deliver_time_in_ms") }}
                      th.sticky-position(width="8%")
                        span(:title="$t('ui.deliver_status')") {{ $t("ui.deliver_status") }}
                  tbody.clusterize-content
                    tr(v-if="filteredMFList.length == 0")
                      td(colspan="12").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in filteredMFList")
                      td.text-center
                        span(:title="item.EventID") {{ item.EventID }}
                      td.text-center
                        span(:title="item.RTFCommentaryID") {{ item.RTFCommentaryID }}
                      td
                        span(:title="item.RTFCommentaryName") {{ item.RTFCommentaryName }}
                      td
                        span(:title="item.Info") {{ item.Info }}
                      td.text-center
                        span
                          i(:class="{'fas fa-check-circle text-success': item.DangerZone == false, 'fas fa-exclamation-triangle text-danger': item.DangerZone == true  }")
                      td.text-right
                        //- span(:title="Math.floor(item.mTime/60000)") {{ Math.floor(item.mTime/60000) }}
                        span(:title="item.mTime") {{ item.mTime }}
                      td
                        span(:title="`${item.LastUpdateTime.split('T')[0]} ${item.LastUpdateTime.split('T')[1]}`") {{ `${item.LastUpdateTime.split('T')[0]} ${item.LastUpdateTime.split('T')[1]}` }}
                      td.text-left
                        span(v-if="item.ArriveTime" :title="`${item.ArriveTime.split('T')[0]} ${item.ArriveTime.split('T')[1]}`") {{ `${item.ArriveTime.split('T')[0]} ${item.ArriveTime.split('T')[1]}` }}
                      td.text-left
                        span(v-if="item.DeliverTime" :title="`${item.DeliverTime.split('T')[0]} ${item.DeliverTime.split('T')[1]}`") {{ `${item.DeliverTime.split('T')[0]} ${item.DeliverTime.split('T')[1]}` }}
                      td.text-right
                        span(:title="item.ArriveTimeInMs") {{ item.ArriveTimeInMs }}
                      td.text-right
                        span(:title="item.DeliverTimeInMs") {{ item.DeliverTimeInMs }}
                      td.text-left
                        span(:title="item.DeliverStatus") {{ item.DeliverStatus }}
            div.row.clusterize.mt-4(v-if="repStatList.length > 0")
              div.col-md-12
                table.tablex(v-for="index in Math.ceil(repKeys.length/14)" style="width:100%")
                  thead
                    tr
                      th.text-center(v-for="index1 in 14")
                        span(:title="repKeys[(index1-1)+(index-1)*14]") {{ repKeys[(index1-1)+(index-1)*14] }}
                  tbody.clusterize-content
                    tr
                      th.text-center(v-for="index1 in 14")
                        span(:title="repList[repKeys[(index1-1)+(index-1)*14]]") {{ repList[repKeys[(index1-1)+(index-1)*14]] }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import DebounceInput from "@/library/DebounceInput";
import matchDetails from "@/components/matchFeed/matchDetails.vue";
import SubmitButton from "@/library/SubmitButton.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    matchDetails
  },
  props: {
    matchId: 0,
    league: '',
    home: '',
    away: ''
  },
  data() {
    return {
      loading: false,
      filterBy: "id",
      mfList: [],
      mfSearch: "",
      repList: [],
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      sort_type: 'desc',
      detailTotalRow: 0,
      currentDetailPage: 1,
      timerId: null,
      refreshTime: 5,
      refreshUpdate: "",
      repStatList: [],
      rtfList: [],
      rtfType: -1,
      eventCodeId: -1,
      eventCode: '',
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    filteredMFList() {
      return this.mfList.filter(mf => {
        if (this.filterBy === "name") {
          return mf.RTFCommentaryName.toLowerCase().indexOf(this.mfSearch.toLowerCase()) > -1;
        } else if (this.filterBy === "id") {
          return mf.RTFCommentaryID.toString().indexOf(this.mfSearch) > -1;
        } else if (this.filterBy === "desc" && mf.Info) {
          return mf.Info.toLowerCase().search(this.mfSearch) > -1;
        }
      });
    },
    repKeys() {
      if (this.repStatList.length > 0)
        return Object.keys(this.repList);

      return [];
    },
    getMFPageSize() {
      return this.$store.getters.mfPageSize;
    },
  },
  created: function() {
    this.$options.refreshEnabled = false;
  },
  mounted: function() {
    this.search();
    this.getRTFList();
  },
  destroyed: function() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  },
  methods: {
    toggleRefresh: function() {
      this.startCountDownRefresh();
    },
    startCountDownRefresh: function() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      if (this.$options.refreshEnabled) {
        this.search();
        this.timerId = setTimeout(() => {
          this.startCountDownRefresh();
        }, this.refreshTime * 1000);
      } else {
        this.refreshUpdate = "STOPPED";
      }
    },
    search() {
      // this.mfList = [];
      // this.repList = [];
      this.getMatchFeeds();
      this.getMatchReps();
    },
    getMatchFeeds: function() {
      let url = config.getMatchFeedsUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.matchfeed,
        RTFMatchID: this.matchId,
        page_number: this.currentDetailPage,
        page_size: this.getMFPageSize,
        sort_type: this.sort_type
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.mfList = [];
                this.mfList = response.data.tbl_match_feeds;
                this.detailTotalRow = this.mfList.length > 0 ? this.mfList[0].totalrows : 0;
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getMatchReps: function() {
      let url = config.getMatchRepStatsUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.matchfeed,
        RTFMatchID: this.matchId
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.repStatList = response.data.tbl_match_repstats;
                this.repList = [];
                this.repList = response.data.tbl_match_repstats[0];
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getRTFList: function() {
      let url = config.getRtfCommUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.rtfcommentary,
        RTFCommentaryID: -1
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.rtfList = response.data.tbl_rtfcommentary;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getEventCode: function(id) {
      return this.rtfList.filter(info => {
        return info.RTFCommentaryID == id;
      });
    },
    sendRBData : function() {
      if (this.rtfType != -1) {
        let url = config.sendRBEventFeedUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.matchfeed,
          game_id: this.matchId,
          event_code_id: this.rtfType,
          event_code: this.getEventCode(this.rtfType).length > 0 ? this.getEventCode(this.rtfType)[0].RTFCommentaryDescription.trim() : '',
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$snotify.success(this.$t("message.success"));
                  this.search();
                  this.rtfType = -1;
                } else {
                  if (this.feedback.status == "requestTooFrequent")
                    this.$helpers.showDialog(this.$t("info"), this.$t("error." + this.feedback.status), "info");
                  else
                    this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.$refs.rtfType.$el.focus();
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.rtfTypeRequired"), "error");
      }
    },
    changedMFPageSize: function(pageSize) {
      this.$store.dispatch("layout/setMFPageSize", pageSize);
      this.currentDetailPage = 1;
      this.getMatchFeeds();
    },
    changedPage: function(pageNo) {
      this.currentDetailPage = pageNo;
      this.getMatchFeeds();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>

<style lang="scss" scoped>
.match-feeds {
  // height: 43vh;
  height: 49vh;
  overflow-y: scroll;
  overflow-x: hidden;
  margin-bottom: 20px;
}
</style>
